module.exports = __webpack_public_path__ + "img/logo-element2.03a70e0e.png";